import { render, staticRenderFns } from "./search_pc.vue?vue&type=template&id=66046140&"
import script from "./search_pc.vue?vue&type=script&lang=js&"
export * from "./search_pc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports